import { useEffect, useState } from "react";
import { fetchBooks, GENRES } from "../lib/api";
import { BookCard } from "../components/BookCard";
import { BookDetailDialog } from "../components/BookDetailDialog";

export default function Livres() {
  const [books, setBooks] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetchBooks(filter === "all" ? {} : { genre: filter })
      .then((data) => {
        setBooks(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [filter]);

  return (
    <div data-testid="page-livres" className="pt-32 pb-20 px-6 md:px-12 lg:px-24 min-h-screen">
      <header className="mb-16 max-w-4xl">
        <p className="text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body mb-6">
          Catalogue complet
        </p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-[#1A1A1A] leading-[1.05] tracking-tight font-light mb-8">
          Tous nos <em className="text-[#2C402E]">livres</em>
        </h1>
        <p className="text-lg text-[#4A4A4A] font-body leading-relaxed max-w-2xl mb-6">
          Parcourez l'ensemble de notre catalogue, organisé par genre littéraire.
        </p>
        <div data-testid="formats-banner" className="border-l-2 border-[#9E4735] pl-5 py-3 bg-[#F4F1EA] max-w-3xl">
          <p className="text-sm font-body text-[#4A4A4A] leading-relaxed">
            <span className="font-medium text-[#1A1A1A]">📖 Nos formats :</span> certains titres sont disponibles en <strong>papier et ebook</strong> sur Amazon, d'autres uniquement en <strong>ebook</strong>. Les livres sans lien Amazon n'ont pas encore de version disponible en ligne, mais ils sont disponibles en <strong>version papier</strong> chez nos partenaires au <strong>Cameroun et au Tchad</strong> — commandables directement auprès de CLED par email.
          </p>
          <p className="text-sm font-body text-[#4A4A4A] leading-relaxed mt-3">
            <span className="font-medium text-[#1A1A1A]">📘 Tous nos livres</span> sont également commandables via la <a href="https://www.facebook.com/share/1BbuPaUifd/" target="_blank" rel="noreferrer" data-testid="livres-fb-link" className="text-[#2C402E] font-medium underline hover:text-[#9E4735] transition-colors">page Facebook Pick & Read</a>.
          </p>
        </div>
      </header>

      {/* Filters */}
      <div
        data-testid="genre-filters"
        className="flex flex-wrap gap-2 md:gap-4 mb-16 pb-6 border-b border-[#D1CFC7]"
      >
        {GENRES.map((g) => (
          <button
            key={g.value}
            onClick={() => setFilter(g.value)}
            data-testid={`filter-${g.value}`}
            className={`px-4 md:px-6 py-2 text-sm font-body tracking-wide border transition-all ${
              filter === g.value
                ? "bg-[#2C402E] text-[#FAF9F6] border-[#2C402E]"
                : "bg-transparent text-[#4A4A4A] border-[#D1CFC7] hover:border-[#2C402E] hover:text-[#2C402E]"
            }`}
          >
            {g.label}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-[#757575] font-body" data-testid="loading-livres">Chargement…</p>
      ) : books.length === 0 ? (
        <p className="text-[#757575] font-body" data-testid="no-livres">Aucun livre dans cette catégorie.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {books.map((book, i) => (
            <BookCard key={book.id} book={book} index={i} onClick={() => setSelected(book)} />
          ))}
        </div>
      )}
      <BookDetailDialog book={selected} open={!!selected} onClose={() => setSelected(null)} />
    </div>
  );
}
